angular
	.module 'App.Repository'

.factory 'VatRateRepository', ['BaseRepository', (BaseRepository) ->
	class VatRateRepository extends BaseRepository
		@resource = '/vat_rates'
		@isRestricted = true

		getPercentageText: (percentage) ->
			return parseFloat((percentage * 100).toFixed(3))

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'percentage', 'ASC'

			super query

	return new VatRateRepository
]
